

import React, { memo } from 'react';
import cx from 'classnames';

import './_elevated-container.scss';







function ElevatedContainer({ children, rounded, className }) {
  return (
    <div className={cx(`elevated-container${rounded ? '--rounded' : ''}`, className)}>
      {children}
    </div>);

}

export default memo(ElevatedContainer);